import { Category } from '@smg-real-estate/hg-rets-schema';
import { getCategoriesForSearchModel, SearchModel } from '@smg-real-estate/hg-search-libs';

import { SearchCriteria } from '@/store/types/search-criteria';

export interface SavedSearch {
  identifier: string;
}

export function polygonSearchCriteria(searchCriteria: SearchCriteria): SearchCriteria {
  return {
    ...searchCriteria,
    polygon: undefined,
    locations: undefined,
    radius: undefined,
    geoLocation: {
      inMultiPolygon: {
        multiPolygon: structuredClone(searchCriteria.polygon),
      },
    },
  };
}

export function cleanupSearchModel(searchModel: SearchModel): SearchCriteria {
  const searchCriteria = {
    ...structuredClone(searchModel),
    page: undefined,
    pageSize: undefined,
    sortDirection: undefined,
    sortType: undefined,
    objectTypes: undefined,
  } as SearchCriteria;

  if (searchCriteria.polygon) {
    return polygonSearchCriteria(searchCriteria);
  }

  return searchCriteria;
}

export function createPayloadSearchCriteria(searchModel: SearchModel): SearchCriteria {
  const { categories, excludeCategories } = getCategoriesForSearchModel(searchModel) as {
    categories: Category[];
    excludeCategories: Category[];
  };

  return {
    ...cleanupSearchModel(searchModel),
    categories,
    excludeCategories,
  };
}
